/* ===================================================================
   LIL' FOODEE — COMING SOON HERO SIGNUP
   Vanilla JS, no dependencies.

   The submit path is IDENTICAL to the Foodee Fam popup: same Klaviyo
   Client Subscription API call, same list, same discount handling.
   Only the profile-source properties differ, so you can tell hero
   signups from popup signups in Klaviyo.

   Once someone signs up here, the popup stays away (it reads the same
   lf_foodee_fam_subscribed localStorage key).
   =================================================================== */
(function () {
  'use strict';

  /* ---------------------------------------------------------------
     1. DISCOUNT — must match an ACTIVE Shopify discount code.
        Verify in Shopify Admin > Discounts before going live; if the
        code does not exist the CTA applies nothing, silently.
     --------------------------------------------------------------- */
  var SETTINGS = {
    discount: {
      code: 'FOODEEFAM',
      shopOrigin: '',              // '' when running on the storefront itself
      redirectPath: '/products/foodee-fan'
    }
  };

  // Same keys the popup uses — do not rename, they are shared on purpose.
  var STORAGE_KEYS = {
    subscribed: 'lf_foodee_fam_subscribed'
  };

  /* ---------------------------------------------------------------
     2. KLAVIYO — PUBLIC values only. Never a private API key here.
     --------------------------------------------------------------- */
  var KLAVIYO = {
    companyId: 'Y6DJYL',           // public company / site ID
    listId:    'T5ERXX',           // Foodee Fam - Email Master (single opt-in)
    revision:  '2026-07-15',

    profileProperties: {
      '$source':          'Foodee Fam Website Hero',
      'LF Signup Source': 'website_hero',
      'LF Form Name':     'Coming Soon Hero',
      'LF Offer Shown':   '10_percent_first_order'
    },

    utmKeys: ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term']
  };

  /* ---------------------------------------------------------------
     3. ELEMENTS
     --------------------------------------------------------------- */
  var form         = document.getElementById('lf-hero-form');
  if (!form) { return; }

  var emailInput   = document.getElementById('lf-hero-email');
  var errorEl      = document.getElementById('lf-hero-error');
  var submitBtn    = document.getElementById('lf-hero-submit');
  var signupState  = document.getElementById('lf-hero-state-signup');
  var successState = document.getElementById('lf-hero-state-success');
  var shopBtn      = document.getElementById('lf-hero-shop');
  var codeValue    = document.getElementById('lf-hero-code-value');
  var codeCopyBtn  = document.getElementById('lf-hero-code-copy');
  var codeStatus   = document.getElementById('lf-hero-code-status');

  /* ---------------------------------------------------------------
     4. STORAGE
     --------------------------------------------------------------- */
  function storageSet(key, value) {
    try { window.localStorage.setItem(key, value); }
    catch (e) { /* private browsing — signup still works */ }
  }

  /* ---------------------------------------------------------------
     5. VALIDATION
     --------------------------------------------------------------- */
  function isValidEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(String(value).trim());
  }

  function showError(message) {
    errorEl.textContent = message;
    emailInput.classList.add('is-invalid');
    emailInput.setAttribute('aria-invalid', 'true');
  }

  function clearError() {
    errorEl.textContent = '';
    emailInput.classList.remove('is-invalid');
    emailInput.removeAttribute('aria-invalid');
  }

  /* ---------------------------------------------------------------
     6. UTM CAPTURE
     --------------------------------------------------------------- */
  function getUtmParameters() {
    var params = {};
    try {
      var search = new URLSearchParams(window.location.search);
      KLAVIYO.utmKeys.forEach(function (key) {
        var value = search.get(key);
        if (value) { params[key] = value; }
      });
    } catch (e) {}
    return params;
  }

  /* ---------------------------------------------------------------
     7. submitToKlaviyo(email)
        Klaviyo Client Subscription API. Authenticates with the PUBLIC
        company ID only. Success is HTTP 202 with an empty body.
     --------------------------------------------------------------- */
  function submitToKlaviyo(email) {
    var profileProperties = Object.assign({}, KLAVIYO.profileProperties, getUtmParameters());
    profileProperties['LF Discount Code'] = SETTINGS.discount.code;

    var body = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: KLAVIYO.profileProperties['$source'],
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                properties: profileProperties,
                subscriptions: {
                  email: { marketing: { consent: 'SUBSCRIBED' } }
                }
              }
            }
          }
        },
        relationships: {
          list: { data: { type: 'list', id: KLAVIYO.listId } }
        }
      }
    };

    var url = 'https://a.klaviyo.com/client/subscriptions/?company_id=' +
              encodeURIComponent(KLAVIYO.companyId);

    return window.fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'revision': KLAVIYO.revision
      },
      body: JSON.stringify(body)
    }).then(function (response) {
      if (!response.ok) { throw new Error('Klaviyo responded ' + response.status); }
      return true;
    });
  }

  /* ---------------------------------------------------------------
     8. DISCOUNT
        Shopify's /discount/CODE?redirect= link applies the discount to
        the session, so nothing has to be pasted at checkout.
     --------------------------------------------------------------- */
  function discountUrl() {
    var d = SETTINGS.discount;
    return (d.shopOrigin || '') + '/discount/' + encodeURIComponent(d.code) +
           '?redirect=' + encodeURIComponent(d.redirectPath);
  }

  function fillDiscount() {
    if (codeValue) { codeValue.textContent = SETTINGS.discount.code; }
    if (shopBtn)   { shopBtn.setAttribute('href', discountUrl()); }
  }

  function copyCode() {
    var code = SETTINGS.discount.code;

    function done() {
      if (codeStatus) { codeStatus.textContent = 'Copied \u2014 ' + code + ' is ready to paste.'; }
      codeCopyBtn.textContent = 'Copied';
      window.setTimeout(function () { codeCopyBtn.textContent = 'Copy'; }, 2400);
    }

    function fallbackCopy() {
      var temp = document.createElement('textarea');
      temp.value = code;
      temp.setAttribute('readonly', '');
      temp.style.position = 'absolute';
      temp.style.left = '-9999px';
      document.body.appendChild(temp);
      temp.select();
      try { document.execCommand('copy'); done(); }
      catch (e) {
        if (codeStatus) { codeStatus.textContent = 'Copy didn\u2019t work \u2014 the code is ' + code + '.'; }
      }
      document.body.removeChild(temp);
    }

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(done, fallbackCopy);
    } else {
      fallbackCopy();
    }
  }

  /* ---------------------------------------------------------------
     9. SUBMIT
     --------------------------------------------------------------- */
  function showSuccessState() {
    signupState.hidden = true;
    successState.style.removeProperty('display');
    successState.hidden = false;
    fillDiscount();
    if (shopBtn) { shopBtn.focus({ preventScroll: true }); }
  }

  function onSubmit(event) {
    event.preventDefault();

    var email = emailInput.value.trim();

    if (!email) {
      showError('Pop your email in first.');
      emailInput.focus();
      return;
    }
    if (!isValidEmail(email)) {
      showError('That email doesn\u2019t look quite right \u2014 mind checking it?');
      emailInput.focus();
      return;
    }

    clearError();
    submitBtn.disabled = true;
    submitBtn.textContent = 'SIGNING YOU UP\u2026';

    submitToKlaviyo(email)
      .then(function () {
        // Shared key: also stops the popup appearing for this visitor.
        storageSet(STORAGE_KEYS.subscribed, 'true');
        showSuccessState();
        window.location.assign(discountUrl());
      })
      .catch(function () {
        showError('Something went wrong at our end. Try again in a moment?');
      })
      .then(function () {
        submitBtn.disabled = false;
        submitBtn.textContent = 'JOIN THE FOODEE FAM';
      });
  }

  /* ---------------------------------------------------------------
     10. WIRING
     --------------------------------------------------------------- */
  fillDiscount();
  form.addEventListener('submit', onSubmit);
  emailInput.addEventListener('input', clearError);
  if (codeCopyBtn) { codeCopyBtn.addEventListener('click', copyCode); }
  if (shopBtn) {
    shopBtn.addEventListener('click', function () {
      storageSet(STORAGE_KEYS.subscribed, 'true');
    });
  }

  window.LilFoodeeHero = {
    showSuccess: showSuccessState,
    submitToKlaviyo: submitToKlaviyo,
    settings: SETTINGS
  };
})();